import { get } from 'lodash';
import { mapActions, mapGetters, mapState } from 'vuex';
import heroUnitSlider from '@/components/home/home-old/hero-unit-slider/hero-unit-slider.vue';
import quotes from '@/components/home/home-old/quotes/quotes.vue';
import howItWorks from '@/components/home/home-old/how-it-works/how-it-works.vue';
import mostPredicted from '@/components/home/home-old/most-predicted/most-predicted.vue';
import mostPredictedList from '@/components/home/home-old/most-predicted-list/most-predicted-list.vue';
import podcasts from '@/components/home/home-old/podcasts/podcasts.vue';
import researchWidget from '@/components/research-widget/research-widget.vue';
import inTheNews from '@/components/home/home-old/in-the-news/in-the-news.vue';
import twitterTimeline from '@/components/twitter/twitter-timeline/twitter-timeline.vue';
import newsFeed from '@/components/home/home-old/news-feed/news-feed.vue';
import insightWidget from '@/components/insight/insight-widget/insight-widget.vue';
import marketBiggestGains from '@/components/market/market-biggest-gains/market-biggest-gains.vue';
import marketMoneyWidget from '@/components/market/market-money-widget/market-money-widget.vue';
import marketCurrentlyPredicting from '@/components/market/market-currently-predicting/market-currently-predicting.vue';
import marketKeyStats from '@/components/market/market-key-stats/market-key-stats.vue';
import marketTopComments from '@/components/market/market-top-comments/market-top-comments.vue';
import contentLoaderMixin from '@/mixins/contentLoader';
import disqusMixin from '@/mixins/disqus';
import homeVideos from '@/components/home/home-old/home-videos';

const REFRESH_ENABLED = true;
const REFRESH_INTERVAL = 10 * 60 * 1000;

export default {
  mixins: [
    contentLoaderMixin,
    disqusMixin,
  ],
  components: {
    heroUnitSlider,
    quotes,
    howItWorks,
    mostPredicted,
    podcasts,
    researchWidget,
    inTheNews,
    twitterTimeline,
    newsFeed,
    mostPredictedList,
    insightWidget,
    marketBiggestGains,
    marketMoneyWidget,
    marketCurrentlyPredicting,
    marketKeyStats,
    marketTopComments,
    homeVideos,
    // eslint-disable-next-line global-require
    ...(process.env.PINNING_ENABLED ? { pinSettingsTrends: require('@/components/pinning/pin-settings-trends/pin-settings-trends.vue').default } : {}),
  },
  data() {
    return {
      interval: null,
    };
  },
  metaInfo() {
    const title = (this.$route.name === 'trends') ? 'Trends' : 'PredictIt';
    return { title };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile', 'isPinningEnabled']),
    ...mapGetters('user', ['isUserRestricted', 'isLoggedIn']),
    ...mapState('popup', ['currentPopup']),
    ...mapState('browse', ['widgets']),
    shouldShowKeyStatsWidgets() {
      return (get(this.widgets, 'key.widgetKeyStats', []) || []).length > 0;
    },
  },
  methods: {
    ...mapActions('browse', ['getWidgets']),
    ...mapActions('popup', ['setCurrentPopup']),
    fetchWidgetsData() {
      this.getWidgets().then(() => {
        this.isComponentReady = true;
      });
      if (REFRESH_ENABLED) {
        if (this.interval) clearInterval(this.interval);
        this.interval = setInterval(() => {
          this.getWidgets();
        }, REFRESH_INTERVAL);
      }
    },
  },
  mounted() {
    this.setupDisqus();
  },
  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  created() {
    this.fetchWidgetsData();
  },
};



// WEBPACK FOOTER //
// ./src/components/home/trends/trends.js